export class RmGrnPlantDetails {
    plantId:number
    grnId:number
    subPlantId?:number
    constructor(plantId:number,grnId:number,subPlantId?:number){
        this.plantId = plantId;
        this.grnId = grnId;
        this.subPlantId = subPlantId;
    }
}